import { AppState } from '../../../../../redux/reducers';
import * as ConceptSponsorStore from '../../../../../redux/middleware/ConceptSponsorMiddleware';
import * as ConceptStore from '../../../../../redux/middleware/ConceptMiddleware';
import { Concept } from '../../../../../models/Entities/Contracts/Concept';
import { ConceptSponsor } from '../../../../../models/Entities/Contracts/ConceptSponsor';

export interface ConceptSponsorFormRow {
  rowKey: string;
  conceptId: number;
  conceptName: string;
  conceptDescription: string;
  conceptReferenceId: string;
  isAssociated: boolean;
  associatedConceptSponsorId?: number;
}

export interface ConceptSponsorFormOwnProps {
  sponsorId: string;
  isOpen: boolean;
  dismissPanel: () => void;
}

interface ConnectedProps {
  isLoading: boolean;
  isLoadingConcepts: boolean;
  isLoadingConceptSponsors: boolean;
  rows: ConceptSponsorFormRow[];
  errorMessage?: string;
}

interface DispatchProps {
  GetAllConceptSponsors: typeof ConceptSponsorStore.actionCreators.GetAllConceptSponsors;
  AddConceptSponsor: typeof ConceptSponsorStore.actionCreators.AddConceptSponsor;
  DeleteConceptSponsor: typeof ConceptSponsorStore.actionCreators.DeleteConceptSponsor;
  GetAllConcepts: typeof ConceptStore.actionCreators.GetAllConcepts;
}

export type Props = ConceptSponsorFormOwnProps & ConnectedProps & DispatchProps;

const normalizeSponsorId = (value?: string): string => (value || '').toLowerCase();

const buildFormRows = (
  concepts: Concept[],
  conceptsAssociated: ConceptSponsor[]
): ConceptSponsorFormRow[] => {
  const associatedByConceptId = new Map<number, ConceptSponsor>(
    conceptsAssociated.map((cs) => [cs.conceptId, cs])
  );

  return concepts.map((concept) => {
    const matchedConceptSponsor = associatedByConceptId.get(concept.id);
    const isAssociated = Boolean(matchedConceptSponsor);

    return {
      rowKey: `concept-${concept.id}`,
      conceptId: concept.id,
      conceptName: concept.conceptName || '',
      conceptDescription: concept.conceptDescription || '',
      conceptReferenceId: concept.conceptReferenceId || '',
      isAssociated,
      associatedConceptSponsorId: matchedConceptSponsor?.id
    };
  });
};

export const mapStateToProps = (state: AppState, ownProps: ConceptSponsorFormOwnProps) => {
  const concepts = state.Concepts?.list || [];
  const normalizedSponsorId = normalizeSponsorId(ownProps.sponsorId);
  const sponsor = state.Sponsor?.list.find(
    (s) => normalizeSponsorId(s.person?.personIdentifier) === normalizedSponsorId
  );
  const conceptsAssociated = sponsor?.conceptsAssociated || [];

  return {
    isLoading: Boolean(state.Concepts?.isLoadingAll),
    isLoadingConcepts: Boolean(state.Concepts?.isLoadingAll),
    isLoadingConceptSponsors: Boolean(state.Concepts?.isLoadingConceptSponsors),
    rows: buildFormRows(concepts, conceptsAssociated),
    errorMessage: state.Concepts?.error?.ErrorMessage
  };
};

export const mapDispatchToProps = {
  GetAllConceptSponsors: ConceptSponsorStore.actionCreators.GetAllConceptSponsors,
  AddConceptSponsor: ConceptSponsorStore.actionCreators.AddConceptSponsor,
  DeleteConceptSponsor: ConceptSponsorStore.actionCreators.DeleteConceptSponsor,
  GetAllConcepts: ConceptStore.actionCreators.GetAllConcepts
};
